import { initBootstrapComponent } from "./utils"

export function init () {
  initBootstrapComponent("modal", { show: false })
}